var _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 46,
    height: 46,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 69,
    height: 69,
    rx: 34.5,
    stroke: "#131313",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAADPklEQVRoge2Zz0tUURTHP9qkWQYpJqXhVqIgotAoN9ki2obopqVZ/4FkEC1McFekf0AQhbWJFi39ByqIiqikKK2YkgjMcsTotTgz9Drvju/e+66T0XzhMvMe9/z4vvvrnHOhiir+b9QE1LMfOF783Q3sALYCtcAi8AF4DjwEpoH7wM9A9r2xE7gAzAGRY5sDxoD20E5dtOjTBIwD3z0c160ATALNoQhEKSROAO8DOK7bPNAfioCJRA0wisxbkwMLwG3gDNANtAD1wEZgO9AFnAZuFvuWIzIB5EIQiJPYANwoY/ANcBZodLCxGRgEZsrovAs0hCBQInHN8H4ZOA9s8jWEjM4wsg5MJLxGwma+zgIHMjiucRjIG+xc9VGW5vwzoM1DTxo6gCcGuT4391d3/guwy1OPDTpIjsQnZNu2RtoI2JwTJj22OEJyTThNJZs1YEPClwDAOSVbwG7aGg37kshCoA54peQv2QrbEkgjkYUAwJCSf4sEhhVDVgJbgK9KR5fuVFFGjvgG3FPvjupO65kASN4Qx0HdYb0TeKSeOytpPOsaAGhVOubDuGYHTWDAQ0e90lGwEVpWQnUehgFWlJ4V3El4EfishFocjZYwQHYSXlPoqRJK7L0OyErikJJ9rDuYdqEX6nmfpTETpoBTwI/YuxxwHTsS2rb2zUjggXrutTC0GlYjsTdF9ph61r4Z0c2fw7aA5LBZoadTWjDYiBTE4r4kDjITakkWqga9XE6iRMImHM8UzI0p4RkkAQ+BPRZ96oHXyodRFyPtJLOiYSc3s2FE2V7CIaEpYVIpKSDVg7VGD8nD9IqPomYkoY4ryiOJ91rBlNR/xDGpj6NfKYuQ0sdakOggeYhGwMmsiicMSvNI9SAUepAvre1cDqE8h5T5tPICUj3wDfYoyo6QnPMRcAepyQZBA2YSEVI9GEJyWFs0FmX0Vhl33ru4Ww45pMBkMhghCfgUv8vrrcgXriv+70aq2LdInrB6xwn25U3owzxfs7Y8ARasLZqQ0TCVxV3bEvLVt1XK+TjakIrZrKWzOrYZRS4KvRHqmrUWiRR7kXuDTiQcKd3aLALvgJdISDyNXLf+9WvWKqr41/ELByIBD5hlE6oAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermTimeIcon);
export default __webpack_public_path__ + "static/media/term-time-icon.852f82ced3dc35a652d6f5847c87259a.svg";
export { ForwardRef as ReactComponent };